import { AxiosRequestConfig } from "axios";
import { CommonAxiosService } from "../common-axios-service";
import { ChapterReqModel, ClassSubjectReq, ClassRequestModel, CommonResponse, CreateQuestionPaperReq, QNPIdReq, QuestionReqModel, SubjectClassReqModel, qPRequestModel, ClassNameRequestModel, ClassSubjectReqModel, ClassIdRequestModel, DefaultModelPaperCheckReqModel, QPaperMergeGerReqModel, QPaperMergeCreateReqModel } from "@boi/shared-models";

export class AiGeneratedQpService extends CommonAxiosService {

    private getURLwithMainEndPoint(childUrl: string) {
        return '/ai_generated_qp/' + childUrl;
    }

    async getAllClasses(config?: AxiosRequestConfig) {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllClasses'), config);
    }

    async getLanguagesByClassSubject(req: ClassSubjectReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getLanguagesByClassSubject'), req, config);
    }

    async getAllLanguages(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllLanguages'), config);
    }

    async getSubjectsByClass(req: ClassRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getSubjectsByClass'), req, config);
    }

    async getChaptersBySubject(req: SubjectClassReqModel, config?: AxiosRequestConfig) {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getChaptersBySubject'), req, config);
    }

    async getTopicsByChapter(req: ChapterReqModel, config?: AxiosRequestConfig) {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getTopicsByChapter'), req, config);
    }

    async getMarksByChapter(req: ChapterReqModel, config?: AxiosRequestConfig) {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getMarksByChapter'), req, config);
    }

    async getMarksByClass(req: ClassIdRequestModel, config?: AxiosRequestConfig) {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getMarksByClass'), req, config);
    }

    async getAllDifficultyLevels(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllDifficultyLevels'), config);
    }

    async getAllQuestionTypes(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionTypes'), config);
    }

    async getAllQuestions(req: QuestionReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestions'), req, config);
    }

    async getAllQuestionsCount(req: QuestionReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionsCount'), req, config);
    }


    async createQuestionPaper(req: CreateQuestionPaperReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createQuestionPaper'), req, config);
    }

    async getAllQuestionPapers(req: qPRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionPapers'), req, config);
    }

    async getAllQuestionPapersToMerge(req: QPaperMergeGerReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionPapersToMerge'), req, config);
    }

    async getQuestionPaperDataById(req: QNPIdReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionPaperDataById'), req, config);
    }

    async generateOtp(req: QNPIdReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('generateOtp'), req, config);
    }

    async isDefaultModelPaperExist(req: DefaultModelPaperCheckReqModel, config?: AxiosRequestConfig) {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('isDefaultModelPaperExist'), req, config);
    }

    async getSubjectsByClassId(req: ClassRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getSubjectsByClassId'), req, config);
    }

    async getBaseSubjectsDropDown(req: ClassRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getBaseSubjectsDropDown'), req, config);
    }

    async getOtherLanguageSubjects(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getOtherLanguageSubjects'), req, config);
    }

    async getAllSubjectIdsForPreview(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllSubjectIdsForPreview'), req, config);
    }


    async getOtherLanguageQuestions(req: CreateQuestionPaperReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getOtherLanguageQuestions'), req, config);
    }

    async getDistinctSubjects(req: ClassNameRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getDistinctSubjects'), req, config);
    }

    async getSubjectByClass(req: ClassIdRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getSubjectByClass'), req, config);
    }

    async getDistinctChapters(req: ClassNameRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getDistinctChapters'), req, config);
    }

    async getChaptersBySubjectAndClass(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getChaptersBySubjectAndClass'), req, config);
    }

    async getDistinctMarks(req: ClassNameRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getDistinctMarks'), req, config);
    }

    async getDistinctMarksFromCreateQuestions(req: ChapterReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getDistinctMarksFromCreateQuestions'), req, config);
    }

    async getChaptersByClassAndSubject(req: ClassSubjectReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getChaptersByClassAndSubject'), req, config);
    }

    async savePaperMergeData(req: QPaperMergeCreateReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('savePaperMergeData'), req, config);
    }

    async getAllPaperMergeData(req: ClassIdRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllPaperMergeData'), req, config);
    }
  
    async getDistinctSubjectsForLogin(): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getDistinctSubjectsForLogin'));
    }


}